import { useRouter } from 'next/router';

import { useWorkspaceRightPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelStore';
import { useURLClipIdSelector } from '~/hooks/useURLClipIdSelector';
import { isPrivateCanvasPagePathname } from '~/utils/PathUtils';

/**
 * Whether the workspace canvas editor is active. Mirrors `PrivateDefaultLayout`'s `canvasOpen` so
 * the panel and the asset-modal inset share one reading. Draft from the asset modal is excluded
 * until the route swaps — standing down at click resizes the modal while it is still on screen.
 * The dedicated canvas page reads its canvas from the URL, so a refresh or browser Back onto it
 * leaves `selectedCanvasId` empty; the route alone means the canvas is open.
 */
export const useWorkspaceAgentPanelCanvasOpen = () => {
  const { pathname } = useRouter();
  const clipId = useURLClipIdSelector();
  const canvasReturnTo = useWorkspaceRightPanelStore((state) => state.canvasReturnTo);
  const draftCanvas = useWorkspaceRightPanelStore((state) => state.draftCanvas);
  const isFullscreen = useWorkspaceRightPanelStore((state) => state.isFullscreen);
  const selectedCanvasId = useWorkspaceRightPanelStore((state) => state.selectedCanvasId);
  const isReturningToAssetModal = Boolean(canvasReturnTo && clipId);

  return {
    canvasOpen: Boolean(
      isPrivateCanvasPagePathname(pathname) ||
        isFullscreen ||
        (!isReturningToAssetModal && (selectedCanvasId || draftCanvas)),
    ),
  };
};
